import React from "react";
import SubtitleAndDescription from "../../Common/SubtitleAndDescription";
import { EXPANSION, PATCH, SEASON, getAbbreviatedClass, getAbbreviatedSpec } from "../../../lib/wowHelpers";
import { getWowStatic } from "hooks/wow/getStaticData";
import Icon from "../../Common/Icon";
import WowTooltip from "../../Tooltips/WowTooltip";
import classnames from "classnames";

const PvPTalents = (props) => {
  const { displayClassName, displaySpecName, pvpTalents } = props;

  return (
    <div className="pvp-talents-container">
      <SubtitleAndDescription
        subtitle={`The Best PvP Talents for ${displaySpecName} ${displayClassName} in ${EXPANSION} Season ${SEASON} Patch ${PATCH}`}
        description={`The top PvP talents used by the best ${getAbbreviatedSpec(displaySpecName)} ${getAbbreviatedClass(
          displayClassName,
        )} players on the PvP leaderboards.`}
      />
      <div className="pvp-talent-boxes-container">
        {pvpTalents.map((talent, index) => (
          <TalentBox talentData={talent} key={index} index={index} />
        ))}
      </div>
    </div>
  );
};

const TalentBox = ({ talentData, index }) => {
  const staticData = getWowStatic("spell", talentData.id);

  let talentName = "";
  let talentImg;
  if (staticData && staticData.name) {
    talentName = staticData.name;
    talentImg = `https://static.bigbrain.gg/wow/spell/assets/${talentData.id}.webp`;
  }

  let borderColor = "#383864";
  if (index < 3) {
    borderColor = "#ff9b00";
  }

  return (
    <div className={classnames("pvp-talent-box", { "gold-outline": index < 3 })} data-spell-id={talentData.id}>
      <div className="talent-icon">
        <WowTooltip type="spell" id={talentData.id}>
          <Icon staticDataImg={talentImg} color={borderColor} />
        </WowTooltip>
      </div>
      <div className="text-container">
        <div className="talent-title">{talentName}</div>
        <div className="talent-pop">{talentData.popularity.toFixed(1) + "%"} Popularity</div>
      </div>
    </div>
  );
};

export default PvPTalents;
